// 组件入口配置信息文件

// 组件文档信息
const componentDocs = [
  {
    "comName": "business/DynamicComponent",
    "displayName": "动态表单组件",
    "path": "/demo/business-dynamic-component/index",
    "exampleName": "business-dynamic-component/index.tsx",
    "category": "Form"
  },
  {
    "comName": "Container",
    "displayName": "详情容器",
    "path": "/demo/container-index",
    "exampleName": "container-index.tsx",
    "category": "Data"
  },
  {
    "comName": "Empty",
    "displayName": "空状态",
    "path": "/demo/empty-index",
    "exampleName": "empty-index.tsx",
    "category": "Basic"
  },
  {
    "comName": "TagGroup",
    "displayName": "标签组",
    "path": "/demo/tag-group-index",
    "exampleName": "tag-group-index.tsx",
    "category": "Data"
  },
  {
    "comName": "ColorText",
    "displayName": "颜色图标文本",
    "path": "/demo/text-color-text",
    "exampleName": "text-color-text.tsx",
    "category": "Text"
  },
  {
    "comName": "CopyTextIcon",
    "displayName": "复制文本图标",
    "path": "/demo/text-copy-text-icon",
    "exampleName": "text-copy-text-icon.tsx",
    "category": "Text"
  },
  {
    "comName": null,
    "displayName": "主页",
    "path": "/demo/index",
    "exampleName": "custom-doc/index/entry.tsx",
    "category": "Introduce"
  },
  {
    "comName": null,
    "displayName": "表单弹出框",
    "path": "/demo/ModalFormDemo",
    "exampleName": "custom-doc/modal-form-demo/entry.tsx",
    "category": "Data"
  },
  {
    "comName": null,
    "displayName": "tabs",
    "path": "/demo/ButtonTabsDemo",
    "exampleName": "custom-doc/button-tabs-demo/entry.tsx",
    "category": "Basic"
  },
  {
    "comName": null,
    "displayName": "Form 组件合集",
    "path": "/demo/form",
    "exampleName": "custom-doc/form/entry.tsx",
    "category": "Form"
  },
  {
    "comName": null,
    "displayName": "青春版选址地图组件Demo",
    "path": "/demo/businessYouthMap",
    "exampleName": "custom-doc/business-youth-map/entry.tsx",
    "category": "Business"
  },
  {
    "comName": null,
    "displayName": "地图商圈详情Demo",
    "path": "/demo/businessYouthMapDetail",
    "exampleName": "custom-doc/business-youth-map-detail/entry.tsx",
    "category": "Business"
  },
  {
    "comName": null,
    "displayName": "Hooks Demo",
    "path": "/demo/hooks",
    "exampleName": "custom-doc/hooks/entry.tsx",
    "category": "Hooks"
  },
  {
    "comName": null,
    "displayName": "Charts Demo",
    "path": "/demo/charts",
    "exampleName": "custom-doc/charts/entry.tsx",
    "category": "Charts"
  },
  {
    "comName": null,
    "displayName": "机会点组件 Demo",
    "path": "/demo/businessChancepoint",
    "exampleName": "custom-doc/business-chancepoint/entry.tsx",
    "category": "Business"
  }
];

// 组件路由信息
const routes = [
  {
    "path": "/demo/business-dynamic-component/index",
    "meta": {
      "name": "demo-动态表单组件",
      "title": "business/DynamicComponent 动态表单组件",
      "isComponentDoc": true,
      "category": "Form",
      "seq": "12.0"
    }
  },
  {
    "path": "/demo/container-index",
    "meta": {
      "name": "demo-详情容器",
      "title": "Container 详情容器",
      "isComponentDoc": true,
      "category": "Data",
      "seq": "5.1"
    }
  },
  {
    "path": "/demo/empty-index",
    "meta": {
      "name": "demo-空状态",
      "title": "Empty 空状态",
      "isComponentDoc": true,
      "category": "Basic",
      "seq": "3.2"
    }
  },
  {
    "path": "/demo/tag-group-index",
    "meta": {
      "name": "demo-标签组",
      "title": "TagGroup 标签组",
      "isComponentDoc": true,
      "category": "Data",
      "seq": "5.3"
    }
  },
  {
    "path": "/demo/text-color-text",
    "meta": {
      "name": "demo-颜色图标文本",
      "title": "ColorText 颜色图标文本",
      "isComponentDoc": true,
      "category": "Text",
      "seq": "7.4"
    }
  },
  {
    "path": "/demo/text-copy-text-icon",
    "meta": {
      "name": "demo-复制文本图标",
      "title": "CopyTextIcon 复制文本图标",
      "isComponentDoc": true,
      "category": "Text",
      "seq": "7.5"
    }
  },
  {
    "path": "/demo/index",
    "meta": {
      "name": "demo-主页",
      "title": "主页",
      "isComponentDoc": true,
      "category": "Introduce",
      "seq": "1.6"
    }
  },
  {
    "path": "/demo/ModalFormDemo",
    "meta": {
      "name": "demo-表单弹出框",
      "title": "表单弹出框",
      "isComponentDoc": true,
      "category": "Data",
      "seq": "5.7"
    }
  },
  {
    "path": "/demo/ButtonTabsDemo",
    "meta": {
      "name": "demo-tabs",
      "title": "tabs",
      "isComponentDoc": true,
      "category": "Basic",
      "seq": "3.8"
    }
  },
  {
    "path": "/demo/form",
    "meta": {
      "name": "demo-Form 组件合集",
      "title": "Form 组件合集",
      "isComponentDoc": true,
      "category": "Form",
      "seq": "12.9"
    }
  },
  {
    "path": "/demo/businessYouthMap",
    "meta": {
      "name": "demo-青春版选址地图组件Demo",
      "title": "青春版选址地图组件Demo",
      "isComponentDoc": true,
      "category": "Business",
      "seq": "-1.10"
    }
  },
  {
    "path": "/demo/businessYouthMapDetail",
    "meta": {
      "name": "demo-地图商圈详情Demo",
      "title": "地图商圈详情Demo",
      "isComponentDoc": true,
      "category": "Business",
      "seq": "-1.11"
    }
  },
  {
    "path": "/demo/hooks",
    "meta": {
      "name": "demo-Hooks Demo",
      "title": "Hooks Demo",
      "isComponentDoc": true,
      "category": "Hooks",
      "seq": "-1.12"
    }
  },
  {
    "path": "/demo/charts",
    "meta": {
      "name": "demo-Charts Demo",
      "title": "Charts Demo",
      "isComponentDoc": true,
      "category": "Charts",
      "seq": "-1.13"
    }
  },
  {
    "path": "/demo/businessChancepoint",
    "meta": {
      "name": "demo-机会点组件 Demo",
      "title": "机会点组件 Demo",
      "isComponentDoc": true,
      "category": "Business",
      "seq": "-1.14"
    }
  }
];

// 组件文档导航信息
const componentDocsMenu = [
  {
    "name": "Business",
    "path": "/demo-category/business",
    "children": [
      {
        "name": "青春版选址地图组件Demo",
        "path": "/demo/businessYouthMap",
        "category": "Business",
        "seq": "-1.10"
      },
      {
        "name": "地图商圈详情Demo",
        "path": "/demo/businessYouthMapDetail",
        "category": "Business",
        "seq": "-1.11"
      },
      {
        "name": "机会点组件 Demo",
        "path": "/demo/businessChancepoint",
        "category": "Business",
        "seq": "-1.14"
      }
    ],
    "seq": -1
  },
  {
    "name": "Hooks",
    "path": "/demo-category/hooks",
    "children": [
      {
        "name": "Hooks Demo",
        "path": "/demo/hooks",
        "category": "Hooks",
        "seq": "-1.12"
      }
    ],
    "seq": -1
  },
  {
    "name": "Charts",
    "path": "/demo-category/charts",
    "children": [
      {
        "name": "Charts Demo",
        "path": "/demo/charts",
        "category": "Charts",
        "seq": "-1.13"
      }
    ],
    "seq": -1
  },
  {
    "name": "Introduce",
    "path": "/demo-category/introduce",
    "children": [
      {
        "name": "主页",
        "path": "/demo/index",
        "category": "Introduce",
        "seq": "1.6"
      }
    ],
    "seq": 1
  },
  {
    "name": "Basic",
    "path": "/demo-category/basic",
    "children": [
      {
        "name": "Empty 空状态",
        "path": "/demo/empty-index",
        "category": "Basic",
        "seq": "3.2"
      },
      {
        "name": "tabs",
        "path": "/demo/ButtonTabsDemo",
        "category": "Basic",
        "seq": "3.8"
      }
    ],
    "seq": 3
  },
  {
    "name": "Data",
    "path": "/demo-category/data",
    "children": [
      {
        "name": "Container 详情容器",
        "path": "/demo/container-index",
        "category": "Data",
        "seq": "5.1"
      },
      {
        "name": "TagGroup 标签组",
        "path": "/demo/tag-group-index",
        "category": "Data",
        "seq": "5.3"
      },
      {
        "name": "表单弹出框",
        "path": "/demo/ModalFormDemo",
        "category": "Data",
        "seq": "5.7"
      }
    ],
    "seq": 5
  },
  {
    "name": "Text",
    "path": "/demo-category/text",
    "children": [
      {
        "name": "ColorText 颜色图标文本",
        "path": "/demo/text-color-text",
        "category": "Text",
        "seq": "7.4"
      },
      {
        "name": "CopyTextIcon 复制文本图标",
        "path": "/demo/text-copy-text-icon",
        "category": "Text",
        "seq": "7.5"
      }
    ],
    "seq": 7
  },
  {
    "name": "Form",
    "path": "/demo-category/form",
    "children": [
      {
        "name": "business/DynamicComponent 动态表单组件",
        "path": "/demo/business-dynamic-component/index",
        "category": "Form",
        "seq": "12.0"
      },
      {
        "name": "Form 组件合集",
        "path": "/demo/form",
        "category": "Form",
        "seq": "12.9"
      }
    ],
    "seq": 12
  }
];

export { componentDocs, routes, componentDocsMenu };